import React, { useMemo } from "react";
import { translate } from "@td/shared_utils";
import { SelectField, Badge } from "@td/ui";
import { fieldTypes } from "../constants";
import { useProviderPanel } from "../contexts/provider-panel-context";
import { orderBy, flatten } from "lodash";
import { filter } from "lodash";

const mapStatesToOptions = (states, practiceTeam) => states.map((state) => ({
  value: state,
  label: `${translate(null, "states.state_codes", state)} ${practiceTeam ? `- ${practiceTeam.toUpperCase()}` : ""}`.trim(),
  isDisabled: !!practiceTeam,
}));

const StatesField = React.memo(() => {
  const { provider, practiceTeamParticipant, isPrincipal } = useProviderPanel();

  const options = useMemo(() => {
    const { availableParticipantStates, practiceTeamParticipants } = provider;
    const availableStates = mapStatesToOptions(availableParticipantStates);

    const selectedStates = practiceTeamParticipants.map(({ practiceTeamId, practiceTeam, principalFlg, states }) => {
      if (principalFlg) {
        return;
      }

      if (practiceTeamParticipant && parseInt(practiceTeamId) == parseInt(practiceTeamParticipant.practiceTeam.id)) {
        return mapStatesToOptions(states);
      } else {
        return mapStatesToOptions(states, practiceTeam.name);
      }
    });

    return orderBy([
      ...availableStates,
      ...filter(flatten(selectedStates), (value) => value),
    ], "isDisabled");
  }, [provider, practiceTeamParticipant]);

  return (
    <SelectField
      isMulti
      isSearchable
      isClearable={false}
      closeMenuOnSelect={false}
      editable={isPrincipal || !!practiceTeamParticipant}
      readOnly={isPrincipal}
      name={fieldTypes.STATES}
      options={options}
      label={`${translate(null, "provider_panel.form.fields.states", "label")}:`}
      placeholder={translate(null, "provider_panel.form.fields.states", "placeholder")}
      formatOptionLabel={({ label, value }, { context }) => context === "menu" ? label : value}
      renderValue={({ value }) => <Badge key={value}>{value}</Badge>}
    />
  );
});

StatesField.displayName = "StatesField";

export default StatesField;
